// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + chunkId + "-" + {"167":"cb1144847b1c9a7173fb","659":"e2d42e8f5c44a7f2c46d","799":"38e8becf20e1a53dbc10"}[chunkId] + ".js";
};